import { Component, OnInit, OnChanges, SimpleChanges, SimpleChange, Input, ChangeDetectionStrategy, ChangeDetectorRef, ErrorHandler } from '@angular/core';
import { AlertModel } from '../models/AlertModel';
import { AlertType } from '../models/AlertType';
import { ObservableErrorHandler } from '../../../core/services/ObservableErrorHandler';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'plr-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit, OnChanges {
  allAlerts: AlertModel[] = [];
  errorHandler: ObservableErrorHandler;

  @Input() errors: string[];

  constructor(private changeDetectorRef: ChangeDetectorRef,
    errorHandler: ErrorHandler) {
    this.errorHandler = errorHandler as ObservableErrorHandler;
    this.errorHandler.errors$.subscribe(e => {
      var errorMessage;
      if (e instanceof HttpErrorResponse) {
        if (e.status === 401) {
          var path = e.url.split('/');
          var method = path[path.length - 2];
          errorMessage = 'Your user account does not have permission to ' + method;
          this.addAlert(new AlertModel(AlertType.Error, errorMessage, e));
        }
      } else if (Object.prototype.toString.call(e) === "[object String]") {
        this.addError(e);
      } else {
        errorMessage = e.error ? e.error.message : null;
        this.addAlert(new AlertModel(AlertType.Error, errorMessage || (e.message || "Unexpected Error Occured"), e));
      }
    });
    this.errorHandler.errorCleared$.subscribe(e => {
      var alert: AlertModel;
      if (Object.prototype.toString.call(e) === "[object String]") {
        alert = this.allAlerts.find(a => a.message === e);
      } else {
        alert = this.allAlerts.find(a => a.error === e);
      }
      this.removeAlert(alert);
    });
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.errors) {
      for (var index in changes.errors.currentValue) {
        this.addError(changes.errors.currentValue[index]);
      }
    }
  }

  removeAlert(alert: AlertModel) {
    if (alert) {
      this.allAlerts = this.allAlerts.filter(a => a != alert);

      this.changeDetectorRef.markForCheck();
    }
  }

  addAlert(alert: AlertModel) {
    if (alert) {
      this.allAlerts = this.allAlerts.concat([alert]);
      this.changeDetectorRef.markForCheck();
    }
  }

  addSuccess(alert: string | AlertModel) {
    alert = typeof alert === 'string' ? new AlertModel(AlertType.Success, alert) : alert;
    this.addAlert(alert);
    setTimeout(() => {
      this.removeAlert(alert as AlertModel);
    }, 5000);
  }

  addError(alert: string | AlertModel) {
    alert = typeof alert === 'string' ? new AlertModel(AlertType.Error, alert) : alert;
    this.addAlert(alert);
  }

  addWarning(alert: string | AlertModel) {
    alert = typeof alert === 'string' ? new AlertModel(AlertType.Warning, alert) : alert;
    this.addAlert(alert);
  }

  addInformation(alert: string | AlertModel) {
    alert = typeof alert === 'string' ? new AlertModel(AlertType.Information, alert) : alert;
    this.addAlert(alert);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/alerts/components/alerts.component.ts